module.exports = "/images/arrow-white-v2.svg?a093dbaf671060df6551e4c4df8064ea";